module.exports = __webpack_public_path__ + "static/media/CANBK.472b987b.txt";